
import Highcharts from 'highcharts';
import { defineComponent } from 'vue';

// eslint-disable-next-line
function doCopy(copy, original, copyArray) {
  // Callback function to iterate on array or object elements
  function callback(value, key) {
    // Copy the contents of objects
    if (
      /* eslint-disable */
      Highcharts.isObject(value, !copyArray) &&
      !Highcharts.isClass(value) &&
      !Highcharts.isDOMElement(value)
      /* eslint-ensable */
    ) {
      copy[key] = doCopy(
        copy[key] || Highcharts.isArray(value) ? [] : {},
        value,
        copyArray,
      );
    } else {
      // Primitives are copied over directly
      copy[key] = original[key];
    }
  }

  if (Highcharts.isArray(original)) {
    original.forEach(callback);
  } else {
    Highcharts.objectEach(original, callback);
  }
  return copy;
}

// eslint-disable-next-line
const copyObject = function (obj, copyArray) {
  return doCopy({}, obj, copyArray);
};

export default defineComponent({
  props: {
    constructorType: {
      type: String,
      default: 'chart',
    },
    options: {
      type: Object,
      required: true,
    },
    callback: Function,
    updateArgs: {
      type: Array,
      default: () => [true, true],
    },
    highcharts: {
      type: Object,
    },
    deepCopyOnUpdate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    options: {
      handler(newValue) {
        this.$nextTick(() => {
          this.chart?.update(
            copyObject(newValue, this.deepCopyOnUpdate),
            ...this.updateArgs,
          );
        });
      },
      deep: true,
    },
  },
  mounted() {
    const HC = this.highcharts || Highcharts;

    // Check whether the chart configuration object is passed, as well as the constructor is valid.
    if (this.options && HC[this.constructorType]) {
      this.chart = HC[this.constructorType](
        this.$refs.chart,
        copyObject(this.options, true), // Always pass the deep copy when generating a chart. #80
        this.callback ? this.callback : null,
      );
    } else {
      !this.options
        ? console.warn('The "options" parameter was not passed.')
        : console.warn(
            `'${this.constructorType}' constructor-type is incorrect. Sometimes this error is caused by the fact, that the corresponding module wasn't imported.`,
          );
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
});
